
import { Cookies } from "react-cookie-consent";
import { desktopImages, mobileImages } from "../Settings/headerImages";

export const fetchBrandImage = (brand) => {
    switch (brand) {
        case "Purple Label":
            return "/static/assets/brandLogo/PurpleLabel.svg";
        case "Double RL":
            return "/static/assets/brandLogo/DoubleRL.svg";
        case "COLLECTION":
            return "/static/assets/brandLogo/Collection.svg";
        default:
            return "";
    }
};
 
export const formatLabel = (text = "", component = "") => {
    if(text) {
        text = text.trim();
        if(component === 'SingleLookTemplate' || component === 'ProductDetailPage') {
            // If the text is exactly three alphabetic characters (e.g., an acronym), keep it uppercase
            if (/^[A-Za-z]{3}$/.test(text)) {
                return text.toUpperCase();
            }
            // else if (/[\/-]/.test(text)) { // If the text contains a slash or hyphen, return it as is
            //     return text;
            // }
            // Otherwise, title-case each word
            return text
                .split(" ")
                .map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ");
        } else {
            if (/\bcollection(s|'s)?\b/i.test(text)) {
                return /\bcollection(s|'s)?\b/i.test(text) ? "COLLECTION" : null;
            }
            else {
                return text;
            }
        }
    } else {
        return ""
    }
}

export const getTitle = (x) => {
    let title = ""
    if (x) {
        if (x.name && x.name !== "" && x.name !== null && x.name !== undefined) {
            title = x.name
        }
    }
    return title
}

export const getFilteredImage = (selectedImage, data) => {
    let img = []
    if (data && data !== undefined && data[0] !== undefined) {
        selectedImage.map(selectImage => {
            data[0].media.filter(item => {
                if (item.type === "Image" && item.url !== selectImage.url) {
                    img.push(item)
                }
            }
            )
        })
    }
    return img
}

export const getFilteredImageSpecific = (selectedImage, data) => {
    let img = []
    selectedImage.map(selectImage => {
        data.media.filter(item => {
            if (item.type === "Image" && item.url !== selectImage.url) {
                img.push(item)
            }
        }
        )
    })
    return img
}

export const resetSummedresponse = () => {
    return {
        outfitUrl: '',
        responseType: "",
        responseTitle: '',
        responseText: '',
        productCollections: [],
        products: [],
        categories: [],
        branding: [],
        responseConclusion: '',
        suggestedPrompts: [],
        messageId: "",
    };
};

export const updateSummedResponse = (currentResponse, response) => {
    if (response.outfitUrl) {
        currentResponse = { ...currentResponse, outfitUrl: response.outfitUrl };
    }
    if (response.badIntentResponseCode) {
        currentResponse = { ...currentResponse, badIntentResponseCode: response.badIntentResponseCode };
    }
    if (response.branding) {
        currentResponse = { ...currentResponse, branding: response.branding };
    }
    if (response.productCollections) {
        currentResponse = { ...currentResponse, productCollections: [...currentResponse.productCollections, ...response.productCollections] };
    }
    if (response.products) {
        currentResponse = { ...currentResponse, products: response.products, outfitUrl: currentResponse.outfitUrl };
    }
    if (response.responseConclusion) {
        currentResponse = {
            ...currentResponse,
            responseConclusion: currentResponse.responseConclusion + response.responseConclusion,
        };
    }
    if (response.responseText) {
        currentResponse = {
            ...currentResponse,
            responseText: currentResponse.responseText + response.responseText,
        };
    }
    if (response.responseTitle) {
        currentResponse = {
            ...currentResponse,
            responseTitle: response.responseTitle,
        };
    }
    if (response.responseType) {
        currentResponse = {
            ...currentResponse,
            responseType: response.responseType,
        };
    }
    if (response.messageId) {
        currentResponse = {
            ...currentResponse,
            messageId: response.messageId,
        };
    }
    if (response.suggestedPrompts) {
        currentResponse = {
            ...currentResponse,
            suggestedPrompts: response.suggestedPrompts,
        };
    }
    return currentResponse;
}

//check two month for feedback
export function isTwoMonthsFromNow(dateString) {
    const givenDate = new Date(dateString);
    const currentDate = new Date();

    // Calculate the difference in days
    const differenceDays = Math.ceil((currentDate - givenDate) / (24 * 60 * 60 * 1000));
    // Check if the difference is greater than 60 days (approximately 2 months)
    return differenceDays > Cookies.get("feedBackCheckMonth");
}

export const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * mobileImages.length);
    return mobileImages[randomIndex];
};

export const getDesktopRandomImage = () => {
    const index = Math.floor(Math.random() * desktopImages.length);
    return desktopImages[index];
};

export const formatUSD = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(amount);
};

export const staticHeader = (titleHeader, element) => {
    const container = document.getElementById(element);
    if (!container) return;

    // Remove previously generated letters before re-rendering.
    container.querySelectorAll(".letter").forEach((letter) => letter.remove());

    titleHeader.split("").forEach((letter, index) => {
        const span = document.createElement("span");
        span.textContent = letter;
        span.classList.add("letter");
        span.style.animationDelay = `${index * 0.01}s`; // Stagger animation
        container.appendChild(span);
    });
}

export const filterOutfitVideoLoader = (prompt) => {
    let outfitLoader = [];
    if (prompt) {
        const womenKeywords = ["lady", "ladies", "women", "girls", "girl", "female", "mother", "mom", "grandma", "grand mother", "grand daughter", "daughter", "daughters"];
        const isWomenKeywordPresent = womenKeywords.some((womenKeyword) => prompt.toLowerCase().includes(womenKeyword.toLowerCase()));
        if (isWomenKeywordPresent) {
            outfitLoader = [
                { "url": "/static/assets/loader/look_card_women.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-WOMENS.png", "loader": true },
                { "url": "/static/assets/loader/look_card_women.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-WOMENS.png", "loader": true },
                { "url": "/static/assets/loader/look_card_women.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-WOMENS.png", "loader": true },
            ]
            // outfitLoader = { "url": "/static/assets/loader/look_card_women.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-WOMENS.png", "loader": true }
        } else {
            const menKeywords = ["men", "man", "boy", "boys", "father", "dad", "grand father", "grand son"];
            const isMenKeywordPresent = menKeywords.some((menKeyword) => prompt.toLowerCase().includes(menKeyword.toLowerCase()));
            if (isMenKeywordPresent) {
                outfitLoader = [
                    { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true, "type": "loader" },
                    { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true, "type": "loader"},
                    { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true, "type": "loader" },
                ]
                // outfitLoader = { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true }
            } else {
                outfitLoader = [
                    { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true },
                    { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true },
                    { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true },
                ]
                // outfitLoader = { "url": "/static/assets/loader/look_card_men.mp4", "fallbackUrl": "/static/assets/loader/fallbackImage/ASK-RALPH-LOADER-MENS.png", "loader": true }
            }
        }
    }
    return outfitLoader;
}

export async function getRandomizedPrompts(response, countPerCategory) {
    const result = [];
    try {
        if (response.ok) {
            const data = await response.json();
            Object.keys(data).forEach(category => {
                const prompts = data[category];
                // Shuffle prompts
                const shuffled = prompts
                    .map(value => ({ value, sort: Math.random() }))
                    .sort((a, b) => a.sort - b.sort)
                    .map(({ value }) => value);
                // Take the first N prompts
                result.push(...shuffled.slice(0, countPerCategory));
            });
            return result;
        }
    } catch (err) {
        return result;
    }
}